import { useTranslation } from 'react-i18next';
import { JOB_APPLICATION__SUCCESS_BODY, JOB_APPLICATION__SUCCESS_TITLE } from 'translations/constants';
import { FormCard, PageIntro, PageTitle } from './styles';

/** Terminal state: no email is sent and no id comes back, so this screen is the only receipt. */
const ApplicationSubmitted = (): JSX.Element => {
  const [t] = useTranslation();

  return (
    <FormCard>
      <PageTitle>{t(JOB_APPLICATION__SUCCESS_TITLE)}</PageTitle>
      <PageIntro>{t(JOB_APPLICATION__SUCCESS_BODY)}</PageIntro>
    </FormCard>
  );
};

export default ApplicationSubmitted;
